"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.POLL_TIMEOUT_MS = exports.POLL_INTERVAL_MS = exports.PAYMENT_METHOD_LABELS = void 0;
exports.confirmNewCactusOrder = confirmNewCactusOrder;
exports.createNewCactusOrder = createNewCactusOrder;
exports.fetchNewCactusConfig = fetchNewCactusConfig;
exports.fetchNewCactusMenu = fetchNewCactusMenu;
exports.formatCurrency = formatCurrency;
exports.getNewCactusOrder = getNewCactusOrder;
exports.pollNewCactusOrder = pollNewCactusOrder;
exports.syncNewCactusLocalCommand = syncNewCactusLocalCommand;
var _api = require("./api");
const base = projectId => `${_api.API_URI}/newcactus/projects/${projectId}`;
async function parseResponse(res) {
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const msg = data.message || data.errors?.items?.[0] || `Erreur (${res.status})`;
    throw new Error(msg);
  }
  return data;
}
async function fetchNewCactusConfig(projectId) {
  const res = await fetch(`${base(projectId)}/config`, {
    headers: {
      Accept: 'application/json'
    }
  });
  return parseResponse(res);
}
async function fetchNewCactusMenu(projectId) {
  const res = await fetch(`${base(projectId)}/menu`, {
    headers: {
      Accept: 'application/json'
    }
  });
  return parseResponse(res);
}
async function createNewCactusOrder(projectId, payload) {
  const res = await fetch(`${base(projectId)}/orders`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify(payload)
  });
  return parseResponse(res);
}
async function getNewCactusOrder(projectId, reference) {
  const res = await fetch(`${base(projectId)}/orders/${encodeURIComponent(reference)}`, {
    headers: {
      Accept: 'application/json'
    }
  });
  return parseResponse(res);
}
async function confirmNewCactusOrder(projectId, reference) {
  const res = await fetch(`${base(projectId)}/orders/${encodeURIComponent(reference)}/confirm`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify({})
  });
  return parseResponse(res);
}
async function syncNewCactusLocalCommand(projectId, payload) {
  const res = await fetch(`${base(projectId)}/sync-command`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify(payload)
  });
  return parseResponse(res);
}
const PAYMENT_METHOD_LABELS = exports.PAYMENT_METHOD_LABELS = {
  cash: 'Espèces',
  card: 'Carte',
  terminal: 'Terminal carte',
  momo: 'MTN MoMo',
  airtel: 'Airtel Money',
  online: 'QR en ligne',
  external: 'Externe',
  stripe_wisepad: 'Carte (WisePad)'
};
const POLL_INTERVAL_MS = exports.POLL_INTERVAL_MS = 3000;
const POLL_TIMEOUT_MS = exports.POLL_TIMEOUT_MS = 90000;
function formatCurrency(value, currency = 'EUR') {
  if (typeof value !== 'number' || Number.isNaN(value)) return '—';
  try {
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: currency.length === 3 ? currency : 'EUR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }).format(value);
  } catch {
    return `${value.toFixed(2)} ${currency}`;
  }
}
async function pollNewCactusOrder(projectId, reference, {
  onTick
} = {}) {
  const deadline = Date.now() + POLL_TIMEOUT_MS;
  while (Date.now() < deadline) {
    const data = await getNewCactusOrder(projectId, reference);
    onTick?.(data);
    const status = data?.payment?.status;
    if (status === 'settled') return {
      ok: true,
      data
    };
    if (status === 'failed') {
      return {
        ok: false,
        data,
        error: 'Paiement refusé ou expiré'
      };
    }
    await new Promise(r => setTimeout(r, POLL_INTERVAL_MS));
  }
  return {
    ok: false,
    error: 'Délai de paiement dépassé (90 s)'
  };
}